export default __webpack_public_path__ + "a201949e042f2e83505751bc50b78f16.png";